var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWave(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 8,
    viewBox: "0 0 12 8",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 12,
    height: 8,
    rx: 2,
    fill: "#007AF0"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2 4H3.0084C3.20599 4 3.38505 3.88363 3.4653 3.70307L4.20976 2.02804C4.38572 1.63213 4.94761 1.63213 5.12357 2.02804L6 4L6.87643 5.97196C7.05239 6.36787 7.61428 6.36787 7.79024 5.97196L8.5347 4.29693C8.61495 4.11637 8.79401 4 8.9916 4H10",
    stroke: "white",
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWave);
export default __webpack_public_path__ + "static/media/wave.ffd5b1a816931bb36dcc1ec23376c95e.svg";
export { ForwardRef as ReactComponent };